var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var CookieRepository_1;
import { IStorageDataSourceType } from '../../DataSource/StorageDataSource/IStorageDataSource';
import { IAnalyticsDataSourceType } from '../../DataSource/AnalyticsDataSource/IAnalyticsDataSource';
import { Observable } from '../../Observable/Observable';
import { injectable } from '../../Decorators/Injectable';
import { inject } from '../../Decorators/Inject';
let CookieRepository = CookieRepository_1 = class CookieRepository {
    constructor(analyticsDataSource, storageDataSource) {
        this.analyticsDataSource = analyticsDataSource;
        this.storageDataSource = storageDataSource;
        this.cookie_settings = new Observable({
            advertising: true,
            essential: true,
            functional: true,
            performance: true,
        });
        this.cookie_settings.observe(this, value => {
            this.analyticsDataSource.setIsEnabledByUser(!!value.performance);
        });
    }
    getCookieSettings() {
        return this.storageDataSource.get(CookieRepository_1.cookie_key)
            .then(settings => {
            if (!settings) {
                settings = this.cookie_settings.value;
            }
            return this.setCookieSettings(settings);
        });
    }
    setCookieSettings(value) {
        this.cookie_settings.update(value);
        return this.storageDataSource.set(CookieRepository_1.cookie_key, this.cookie_settings.value).then(() => this.cookie_settings);
    }
};
CookieRepository.cookie_key = 'cookie_settings';
CookieRepository = CookieRepository_1 = __decorate([
    injectable({ type: 'singleton' }),
    __param(0, inject(IAnalyticsDataSourceType)),
    __param(1, inject(IStorageDataSourceType)),
    __metadata("design:paramtypes", [Object, Object])
], CookieRepository);
export { CookieRepository };
